"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickBaseUrlsOfServices = pickBaseUrlsOfServices;
/**
 * Pick base URLs of @see {requiredServices} and @see {optionalServices} if available from @see {allServiceUrls} dataset.
 * Throws when any of the required URLs is unavailable.
 * All returned URL properties gain postfix "Url" to be more easily consumable by the current ecosystem.
 * @param allServiceUrls All available services with URLs
 * @param requiredServices Names of services from @see {allServiceUrls} that should be picked and that are required to be in the dataset
 * @param optionalServices Names of services from @see {allServiceUrls} that should be picked but are not required to be in the dataset nor in the output
 * @returns Base URLs of @see {requiredServices} and @see {optionalServices} if available. All URL properties gain postfix "Url".
 */
function pickBaseUrlsOfServices(allServiceUrls, requiredServices, optionalServices) {
  const uniqueRequiredServices = [...new Set(requiredServices)];

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Data is filled-in in the following reducers
  const pickedUrls = {};
  uniqueRequiredServices.reduce((accumulator, serviceName) => {
    const url = allServiceUrls[serviceName]?.baseUrl;
    if (!url) {
      throw new Error(`Required service '${serviceName}' or its base url not found in passed data`);
    }
    accumulator[`${serviceName}Url`] = url;
    return accumulator;
  }, pickedUrls);
  const uniqueOptionalServices = [...new Set(optionalServices)];
  uniqueOptionalServices.reduce((accumulator, serviceName) => {
    const url = allServiceUrls[serviceName]?.baseUrl;
    if (url) {
      accumulator[`${serviceName}Url`] = url;
    }
    return accumulator;
  }, pickedUrls);
  return pickedUrls;
}
//# sourceMappingURL=pickBaseUrlsOfServices.js.map